export const forumCategories = [
  { value: 'help', label: 'Help' },
  { value: 'bugs', label: 'Bugs' },
  { value: 'providers', label: 'Providers' },
  { value: 'mail-setup', label: 'Mail setup' },
  { value: 'security', label: 'Security' },
  { value: 'feature-request', label: 'Feature request' },
  { value: 'show-and-tell', label: 'Show and tell' },
  { value: 'announcement', label: 'Announcement' },
] as const

export const forumTags = [
  'Gmail',
  'Outlook',
  'iCloud',
  'Yahoo',
  'Fastmail',
  'IMAP',
  'SMTP',
  'Security',
  'Signatures',
  'macOS',
  'Windows',
  'Linux',
  'Feature request',
] as const

export const forumBadges = [
  { value: 'contributor', label: 'Contributor' },
  { value: 'provider-tester', label: 'Provider tester' },
  { value: 'forum-helper', label: 'Forum helper' },
  { value: 'beta-tester', label: 'Beta tester' },
] as const

export function categoryLabel(value: string) {
  return forumCategories.find((category) => category.value === value)?.label || value
}

export function badgeLabel(value: string) {
  return forumBadges.find((badge) => badge.value === value)?.label || value
}
